import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Box from "../../../components/Box";
import { Helpers } from "../../../helpers/Helpers";
import { KTCard } from "../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../_metronic/helpers/components/KTCardBody";
import Content from "../../../_metronic/layout/components/content/Content";
import { ToolbarWrapper } from "../../../_metronic/layout/components/toolbar";
import { PageTitle } from "../../../_metronic/layout/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { storeActivityIndicator } from "../../../redux/reducers/authSlice";
import toast from "react-hot-toast";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../components/CustomSingleSelect";
import { ConstantService } from "../../../services/ConstantService";
import { CaseService } from "../../../services/CaseService";
import { AddCaseResponse } from "../../../models/response/case/AddCaseResponse";
import { GetCaseByIdResponse } from "../../../models/response/case/GetCaseByIdResponse";

const CaseAdd = () => {
    const navigate = useNavigate();
    const pageName = "Ön Muhasebe > Tanımlamalar > Kasa Tanımları"
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch();

    const [caseId, setCaseId] = useState<string | undefined>(undefined);
    const [name, setName] = useState<string | undefined>(undefined);
    const [accountingCode, setAccountingCode] = useState<string | undefined>(undefined);
    const [openingBalance, setOpeningBalance] = useState<string | undefined>(undefined);
    const [selectedCurrencyType, setSelectedCurrencyType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [openingBalanceDate, setOpeningBalanceDate] = useState<string | undefined>(undefined);
    const [isCustomActive, setIsCustomActive] = useState(true);

    useEffect(() => {
        var id = searchParams.get("id");
        getData(id);
    }, [])

    const getData = async (_id: string | undefined | null = undefined) => {
        try {
            dispatch(storeActivityIndicator(true));

            var id = _id ? _id : searchParams.get("id") ? searchParams.get("id") : undefined;

            if (id) {
                var response: GetCaseByIdResponse = await CaseService.getCaseById(id);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                setCaseId(response.data.caseId);
                setName(response.data.name);
                setAccountingCode(response.data.accountingCode);

                setOpeningBalance(response.data.openingBalance.toString());

                if (response.data.currencyTypeId)
                    setSelectedCurrencyType({ label: response.data.currencyTypeName, value: response.data.currencyTypeId });

                setOpeningBalanceDate(response.data.openingBalanceDate);
                setIsCustomActive(response.data.isCustomActive);
            }
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }
    const saveCase = async () => {
        try {
            if (Helpers.isEmpty(name))
                toast.error('Kasa Adı alanını doldurunuz!')
            else if (Helpers.isEmpty(openingBalance))
                toast.error('Açılış Bakiyesi alanını doldurunuz!')
            else if (!selectedCurrencyType)
                toast.error('Döviz Cinsi alanını doldurunuz!')
            else if (Helpers.isEmpty(openingBalanceDate))
                toast.error('Açılış Bakiyesi Tarihi alanını doldurunuz!')
            else {
                dispatch(storeActivityIndicator(true));

                var response: AddCaseResponse = await CaseService.addCase(caseId, name, openingBalance, selectedCurrencyType?.value, accountingCode, openingBalanceDate, isCustomActive ? 1 : 0);

                if (!response.isSuccess) {
                    toast.error(response.message);
                    dispatch(storeActivityIndicator(false));
                    return;
                }

                toast.success(response.message)

                dispatch(storeActivityIndicator(false));
                navigate(Helpers.getGoBackUrl())
            }
        } catch (error: any) {
            toast.error(error);
            dispatch(storeActivityIndicator(false));
        }
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={undefined} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Box className="mb-10">
                <Content>
                    <div>
                        <KTCard className="ebbe-card">
                            <KTCardBody>
                                <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                                <div className='row'>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Kasa Adı</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Açılış Bakiyesi</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={openingBalance} onChange={(e) => setOpeningBalance(e.target.value)} type="number" className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <div className="form-check form-check-custom form-check-solid d-flex">
                                                <input onChange={(e) => { setIsCustomActive(!isCustomActive) }} className="form-check-input" type="checkbox" value="" id={"deviceCrudIsCustomActiveYes"} checked={isCustomActive} />
                                                <label className="form-check-label text-gray-800" htmlFor={"deviceCrudIsCustomActiveYes"}>
                                                    Aktif
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Muhasebe Kodu</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={accountingCode} onChange={(e) => setAccountingCode(e.target.value)} type="text" className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Açılış Bakiye Tarihi</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={openingBalanceDate} onChange={(e) => setOpeningBalanceDate(e.target.value)} type="date" className="form-control form-control-solid" />
                                        </div>
                                    </div>

                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label required">Döviz Cinsi</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedCurrencyType}
                                                onChange={setSelectedCurrencyType}
                                                onMenuOpen={() => ConstantService.getConstantList('CURRENCY')}
                                                labelName='additionalValue1'
                                                valueName='constantId'
                                            />
                                        </div>
                                    </div>
                                </div>
                            </KTCardBody>
                        </KTCard>
                    </div>

                    <KTCard className="ebbe-card mt-10">
                        <KTCardBody>
                            <Box flexDirection="row" justifyContent="flex-end">
                                <Box mr="15px">

                                    <button className="btn btn-sm btn-light btn-active-light-primary" onClick={() => navigate(Helpers.getGoBackUrl())}>Geri</button>
                                </Box>
                                <Box>
                                    <button className="btn btn-primary btn-sm" onClick={saveCase}>Kaydet</button>
                                </Box>
                            </Box>
                        </KTCardBody>
                    </KTCard>
                </Content>
            </Box>
        </React.Fragment>
    )
}

export default CaseAdd;